import { jsx as _jsx } from "react/jsx-runtime";
// Styles are inlined as these components will be rendered for PDF generation
export const NotificationContainerView = ({ children }) => {
    return (_jsx("div", { "data-study-product-version": 'r440', style: {
            height: '100%',
            boxSizing: 'border-box',
            margin: 0,
            fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        }, children: children }));
};
//# sourceMappingURL=notification_container_view.js.map